import { CompteMobileLight } from '../dto/compte-mobile.light.model';
import { PhotoProfileDTO } from './photo-profil.dto';

export class UserDTO extends CompteMobileLight {
  constructor(
    id: string,
    lastName: string | undefined,
    firstName: string | undefined,
    public readonly photo: PhotoProfileDTO | undefined
  ) {
    super(id, lastName, firstName);
  }

  public static hydrate(obj: UserDTO): UserDTO {
    return new UserDTO(obj.id, obj.lastName, obj.firstName, obj.photo ? PhotoProfileDTO.hydrate(obj.photo) : undefined);
  }
}
